var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex gap-2" },
      [
        _c(
          "v-switch",
          _vm._g(
            {
              staticClass: "h-8 mt-0",
              attrs: {
                "input-value": _vm.value,
                disabled: _vm.loading,
                inset: "",
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("input", $event)
                },
              },
            },
            _vm.$listeners
          )
        ),
        _c("div", { staticClass: "flex items-center gap-2" }, [
          _c("div", { staticClass: "text-base font-medium" }, [
            _vm._v(" " + _vm._s(_vm.text) + " "),
          ]),
          _c(
            "div",
            [
              _vm.loading
                ? _c("v-progress-circular", {
                    attrs: { size: "16", width: "2", indeterminate: "" },
                  })
                : _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _c("v-img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.icon && !_vm.isTimeout,
                            expression: "icon && !isTimeout",
                          },
                        ],
                        attrs: {
                          src: _vm.icon,
                          height: "16",
                          eager: "",
                          contain: "",
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm.description
      ? _c(
          "div",
          { staticClass: "text-order-closed text-sm font-normal pl-16" },
          [_vm._v(" " + _vm._s(_vm.description) + " ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }